package org.multiplatform.kotfolio.pages.kids

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("river_system")
@Composable
fun RiverSystemPage() {
    BlogLayout(
        PageProperties(
            "River System",
            ""
        ),
        BlogProperties("Class - 5", "River System (Water Bodies, Geography, Major Domains of the Earth, Geographical Diversity of India)")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "River",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "River is the life line and blood line of India. The origin and distribution of the main streams and their tributaries is known as 'Drainage System or River System",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In geography, a drainage system refers to the pattern formed by a river and its tributaries as they collect and channel water into a larger water body such as a sea, ocean, or lake.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "River: A large stream of water that flows over the land.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Drainage basin - The area drained by a river and its tributaries.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Water divide - A highland that separates two drainage basins.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Stream: A small, narrow flow of water.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Water divide - A highland that separates two drainage basins.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Tributary: A smaller river or stream that flows into a larger river.  A smaller river that joins a main river.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "River system - The main river along with all its tributaries.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Gorge - A deep narrow passage with steep rocky sides through which a river may flow is called Gorge.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Formation and How It Works",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The formation of the drainage systems of India is closely linked to geological structure, relief features, and climate. The Himalayan rivers were formed due to tectonic activities and uplift of the Himalayas, while the Peninsular rivers developed over ancient landmasses.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Rainfall and melting of glaciers provide water to rivers.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Water flows from higher elevation to lower areas due to gravity.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Small streams join to form larger rivers and tributaries.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Rivers erode, transport, and deposit sediments along their course.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Finally, rivers drain into the Bay of Bengal, Arabian Sea, or inland basins.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Types of rivers in India",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Most of the rivers in India either flow into the Arabian Sea or the Bay of Bengal, which is determined by the water shed and the physical features of the country.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Himalayan Rivers (Indus, the Ganga and the Brahmaputra): These rivers receive water from rain as well as from melted snow from high mountains. Two major Himalayan rivers, the Indus and the Brahmaputra originate from the north of the mountain ranges.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Peninsular Rivers (Narmada Basin, Tapi Basin, Godavari Basin, Mahanadi Basin, Krishna Basin, Kaveri Basin): Peninsular rivers are seasonal. The flow of these rivers is dependent on rainfall. Most of the rivers of peninsular India originate in the Western Ghats and flow towards the Bay of Bengal.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Indus",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The river Indus rises in Tibet, near Lake Mansarowar.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flowing west, it enters India in the Ladakh.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It forms a picturesque gorge in this part.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Several tributaries, the Zaskar, the Nubra, the Shyok and the Hunza, join it in the Kashmir region.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The Indus flows through Baltistan and Gilgit and emerges from the mountains at Attock.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The Satluj, the Beas, the Ravi, the Chenab and the Jhelum join together to enter the Indus near Mithankot in Pakistan.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Beyond this, the Indus flows southwards eventually reaching the Arabian Sea, east of Karachi.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The Indus plain has a very gentle slope.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "With a total length of 2900 km, the Indus is one of the longest rivers of the world.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A little over a third of the Indus basin is located in India Ladakh, Jammu and Kashmir, Himachal Pradesh and Punjab and the rest is in Pakistan.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Brahmaputra",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The Brahmaputra rises in Tibet east of Mansarowar Lake, which is also a source of the Indus and Sutlej.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "It is 3848kms long, a little longer than the Indus River. Most of its course lies outside India.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "It flows parallel to the Himalayas in the eastward direction. When it reaches Namcha Barwa, it takes a U-turn around it and enters India in the state of Arunachal Pradesh. Here it is known as the Dihang River. In India, it flows through the states of Arunachal Pradesh and Assam and is connected by several tributaries.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "The river is known as the Tsangpo (સાંગપો) in Tibet.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "It is known for creating calamities (આપત્તિઓ) in Assam and Bangladesh. The Brahmaputra overflows to flood the banks of Assam. Every year during the rainy season, the river overflows its banks, causing widespread devastation due to floods in Assam and Bangladesh.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "The Brahmaputra has a braided channel throughout most of its length in Assam.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Brahmaputra is known as the Tsang Po in Tibet. The river Brahmaputra is known as dihang in Arunachal Pradesh, as Brahmaputra in Assam and Jamuna in Bangladesh.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "River Damodar is known as the 'Sorrow of Bengal' as it causes widespread destruction of lives, cattle and crops due to frequent fooding. It joins Ganga from the right.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "The Brahmaputra finally joins which river system before reaching the Bay of Bengal? Ganga",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "The Brahmaputra River is known for causing frequent ______ in Assam. Floods",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Majuli, one of the world's famous river islands, is located on which river? Brahmaputra",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "The Brahmaputra flows through India and which neighboring country? Bangladesh",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }
        }
    }
}

//Treaty: સંધિ

//https://kpskendriyavidyalaya.com/notesdetails?syllabus=CBSE&classname=Class%209&subject=Geography&chap=3.%20DRAINAGE&notestype=Notes
//https://www.scribd.com/document/771817426/Class-9-Geography-Chapter-3-Drainage
//https://byjus.com/free-ias-prep/major-river-systems-in-india
//https://sudarshangurjar.com/indian-river-system-drainage-systems-of-india/